import { render, staticRenderFns } from "./InternalRequestByModuleMonthlyReportTable.vue?vue&type=template&id=e38ae108&scoped=true&"
import script from "./InternalRequestByModuleMonthlyReportTable.vue?vue&type=script&lang=js&"
export * from "./InternalRequestByModuleMonthlyReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38ae108",
  null
  
)

export default component.exports